import React, { useId } from "react";
import { cn } from "@/lib/utils";

interface CircleFillCheckmarkIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export const CircleFillCheckmarkIcon: React.FC<
  CircleFillCheckmarkIconProps
> = ({ className, color, ...props }) => {
  const clipId = useId();
  return (
    <svg width="20" height="20" viewBox="-2 -2 20 20" fill="none">
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M7.99999 14.6666C11.6819 14.6666 14.6667 11.6818 14.6667 7.99992C14.6667 4.31802 11.6819 1.33325 7.99999 1.33325C4.3181 1.33325 1.33333 4.31802 1.33333 7.99992C1.33333 11.6818 4.3181 14.6666 7.99999 14.6666Z"
          fill={color}
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 8.00008L7.33333 9.33341L10 6.66675"
          stroke="#F5F5F6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
